import React from 'react'
import { Disclosure } from '@headlessui/react'

export interface AppDisclosureItem {
  question: string
  answer: React.ReactNode
}

interface AppDisclosureProps {
  items: AppDisclosureItem[]
}

export const AppDisclosure: React.FC<AppDisclosureProps> = ({ items }) => (
  <div>
    {items.map((item, index) => (
      <Disclosure key={index}>
        {({ open }) => (
          <>
            <Disclosure.Button
              className="
                flex w-full justify-between items-center py-4 text-left text-sm font-medium
                text-[color:var(--ink)]
                border-b border-[color:var(--border)]
                focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--accent)]/30 focus-visible:ring-offset-2
                rounded-sm
              "
            >
              <span>{item.question}</span>
              <svg
                aria-hidden
                className={`w-4 h-4 text-[color:var(--ink-faint)] flex-shrink-0 ml-4 transition-transform duration-200 ${
                  open ? 'rotate-180' : ''
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </Disclosure.Button>
            <div
              className={`grid transition-[grid-template-rows,opacity] duration-300 ease-[cubic-bezier(0.25,1,0.5,1)] ${
                open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
              }`}
            >
              <div className="overflow-hidden">
                <Disclosure.Panel className="pb-4 pt-2 text-sm text-[color:var(--ink-soft)] leading-relaxed whitespace-pre-line">
                  {item.answer}
                </Disclosure.Panel>
              </div>
            </div>
          </>
        )}
      </Disclosure>
    ))}
  </div>
)

export default AppDisclosure
